import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.04182 12C9.04182 10.343 10.3848 9 12.0418 9C13.6988 9 15.0418 10.343 15.0418 12C15.0418 13.657 13.6988 15 12.0418 15C10.3848 15 9.04182 13.657 9.04182 12ZM11.0418 12C11.0418 12.551 11.4908 13 12.0418 13C12.5928 13 13.0418 12.551 13.0418 12C13.0418 11.449 12.5928 11 12.0418 11C11.4908 11 11.0418 11.449 11.0418 12Z", clipRule: "evenodd" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.99982 12C3.29082 7.953 7.29482 5 12.0418 5C16.7888 5 20.7928 7.953 22.0838 12C20.7928 16.047 16.7888 19 12.0418 19C7.29482 19 3.29082 16.047 1.99982 12ZM4.12982 12C5.37882 14.974 8.53782 17 12.0418 17C15.5458 17 18.7048 14.974 19.9538 12C18.7048 9.026 15.5458 7 12.0418 7C8.53782 7 5.37882 9.026 4.12982 12Z", clipRule: "evenodd" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconEye = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconEye.displayName = "IconEye";

export { IconEye };
